import { getDeliveryApiBase } from "./deliveryApi";
import { getTranslator } from "../i18n";

export function isFeedbackApiConfigured() {
    return Boolean(getDeliveryApiBase());
}

export async function submitFeedback({ sourceType, linkId, albumPath, albumName, content, contact }) {
    const apiBase = getDeliveryApiBase();
    if (!apiBase) {
        const error = new Error(getTranslator()("feedback.api.missingApi"));
        error.code = "MISSING_API";
        throw error;
    }

    const body = {
        sourceType,
        linkId,
        albumPath,
        albumName,
        content,
    };
    if (contact) {
        body.contact = contact;
    }

    let response;
    try {
        response = await fetch(`${apiBase}/api/feedback`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            cache: "no-store",
            body: JSON.stringify(body),
        });
    } catch {
        const error = new Error("FEEDBACK_SUBMIT_FAILED");
        error.code = "NETWORK_ERROR";
        throw error;
    }

    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        const error = new Error(payload.error?.message || "FEEDBACK_SUBMIT_FAILED");
        error.code = "API_ERROR";
        error.status = response.status;
        throw error;
    }

    return response.json().catch(() => ({}));
}
